query simpleFootballTeams($search: String) {
  teams: allFootballTeams(
    orderBy: NAME_ASC
    first: 20
    filter: { name: { includesInsensitive: $search } }
  ) {
    nodes {
      id: teamId
      name
    }
  }
}
